export const ADD_APOLLO_ERROR = 'ADD_APOLLO_ERROR';
export const CLEAR_APOLLO_ERROR = 'CLEAR_APOLLO_ERROR';

const ApolloErrorActions = {
  ADD_APOLLO_ERROR,
  CLEAR_APOLLO_ERROR,
  showApolloError: apolloError => ({
    type: ADD_APOLLO_ERROR,
    apolloError,
  }),
  clearApolloError: () => ({
    type: CLEAR_APOLLO_ERROR,
  }),
};

export default ApolloErrorActions;
